import * as z from 'zod';

export const doctorLeaveRequestFormSchema = z
  .object({
    UserId: z.string().min(1, { message: 'EMPLOYEE_REQUIRED' }),
    StartDate: z.string().min(1, { message: 'START_DATE_REQUIRED' }),
    EndDate: z.string().min(1, { message: 'END_DATE_REQUIRED' }),
    Reason: z
      .string()
      .min(1, { message: 'REASON_REQUIRED' })
      .max(500, { message: 'REASON_TOO_LONG' }),
  })
  .refine((data) => data.StartDate <= data.EndDate, {
    message: 'START_DATE_MUST_NOT_BE_AFTER_END_DATE',
    path: ['EndDate'],
  });

export type DoctorLeaveRequestFormValues = z.infer<typeof doctorLeaveRequestFormSchema>;
